import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent {
  @Input() public saml: boolean;
  @Input() public errored: boolean;
  @Input() public originalUrl: string;
  @Input() public onSignInWithQIdentity: () => boolean;
  @Input() public onSignInWithQAzure: () => boolean;
  @Input() public onSignInWithEmail: (email: string) => boolean;
  
  constructor(private route: ActivatedRoute) {}
  
  ngOnInit(): void {
    var parsedURL = new URL(this.originalUrl);
    if (this.errored) {
      return
    } else if (parsedURL.searchParams.get('signInMethod') === "internal") {
      this.onSignInWithQAzure();
    } else {
      this.onSignInWithQIdentity();
    }
  }

}
